export const facilities = [
  ['massTransit', '大眾運輸', 'commute'],
  ['majorConstruction', '重大建設', 'foundation'],
  ['departmentStore', '百貨賣場', 'attractions'],
  ['medicalInformation', '醫療資訊', 'medication'],
  ['leisureFacilities', '休閒設施', 'liquor'],
  ['supermarket', '生活超商', 'shopping_bag'],
  ['traditionalMarket', '傳統市場', 'storefront'],
  ['shoppingDistrict', '購物商圈', 'store'],
  ['educationSchools', '教育學校', 'school'],
];
